import { Application } from "../config";
import { images } from "../images";

const { isNemi, isAmb, isIframe } = Application

const appsStyle = [
    { name: 'Nemi', style: 'nemi', selected: isNemi },
    { name: 'AMB', style: 'amb', selected: isAmb },
    { name: 'Iframe', style: 'iframe', selected: isIframe }
]

const appsGeneralInfo = [
    { name: 'Nemi', id: 'Nemi', title: 'Nemi Your digital partner', copyright: '© Nemi', selected: isNemi },
    { name: 'AMB', id: 'AMB', title: 'Àrea Metropolitana de Barcelona', copyright: '© Àrea Metropolitana de Barcelona', selected: isAmb },
    { name: 'Iframe', id: 'Iframe', title: 'Iframe', copyright: '© Iframe', selected: isIframe },
]

const appsURLS = [
    { name: 'Nemi', home: 'http://nemi.mobi', contact: 'http://www.nemi.mobi/#contact', linkedin: 'https://es.linkedin.com/company/ne-mi', twitter: 'https://twitter.com/nemidrt', selected: isNemi },
    { name: 'AMB', home: 'http://www.amb.cat/s/home.html', contact: 'http://www.amb.cat/web/amb/seu-electronica/suggeriments-i-queixes', linkedin: 'https://www.linkedin.com/cws/share?url=http://www.amb.cat/guia-estils', twitter: '', selected: isAmb },
    { name: 'Iframe', home: 'http://nemi.mobi', contact: 'http://www.nemi.mobi/#contact', linkedin: 'https://es.linkedin.com/company/ne-mi', twitter: 'https://twitter.com/nemidrt', selected: isIframe },
]

const appsLogos = [
    { name: 'Nemi', logo: images['logoNemiOnlyN'], logoRounded: images['logoNemiRounded'], alt: 'Nemi', class: 'logo nemi', classRounded: 'logoNemiRounded', selected: isNemi },
    { name: 'AMB', logo: images['logoWhite'],logoRounded: images['logoAmb'], alt: 'AMB:Bus Metropolità', class: 'logo', classRounded: 'logoAmb', selected: isAmb },
    { name: 'Iframe', logo: images['logoNemiOnlyN'], logoRounded: images['logoNemiRounded'], alt: 'Nemi', class: 'logo nemi', classRounded: 'logoNemiRounded', selected: isIframe },
]

const appsPrivacyAndTermsOptions = [
    { name: 'Nemi', privacy: `http://www.nemi.mobi/app/legal/`, terms: `http://www.nemi.mobi/app/terms/`, owner: 'Nemi Mobility Solutions SL', someLanguages: true, selected: isNemi },
    { name: 'AMB', privacy: 'http://www.amb.cat/web/mobilitat/autobus/busademanda/cervello', terms: 'http://www.amb.cat/web/mobilitat/autobus/busademanda/cervello', owner: null, someLanguages: false, selected: isAmb },
    { name: 'Iframe', privacy: `https://www.divertisenvivo.com/politica-privacidad-venta-online`, terms: `https://www.divertisenvivo.com/terminos-y-condiciones/`, owner: 'Divertis en vivo', someLanguages: false, selected: isIframe },
]

const appsLanguagePosition = [
    { name: 'Nemi', languages: [ 'en', 'es', 'ca', 'it', 'fr' ], selected: isNemi },
    { name: 'AMB', languages: [ 'ca', 'es', 'en', 'it', 'fr' ], selected: isAmb },
    { name: 'Iframe', languages: [ 'en', 'es', 'ca', 'it', 'fr' ], selected: isIframe },
]

export const appsStyleSelected = appsStyle.find(app => app.selected)

export const appsGeneralInfoSelected = appsGeneralInfo.find(app => app.selected)

export const appsURLSSelected = appsURLS.find(app => app.selected)

export const appsLogosSelected = appsLogos.find(app => app.selected)

export const appsPrivacyAndTermsOptionsSelected = appsPrivacyAndTermsOptions.find(app => app.selected)

export const appsLanguagePositionSelected = appsLanguagePosition.find(app => app.selected)